import React from 'react';
import styled from 'styled-components';
import { TopProject } from '../../../types/globalTypes';
import { COLORS, device } from '../../../constants';
import { PortfolioCard } from '../../home/partials/Pofrtolio/PortfolioCard';
import { Text } from '../../../components';
import { useTranslation } from 'react-i18next';
import { MotionPortfolioProjectList } from '../../../components/Motion';

interface PortfolioListProps {
  projects: TopProject[];
}

const PortfolioList = ({ projects }: PortfolioListProps) => {
  const { t } = useTranslation();
  return (
    <PortfolioListWrapper>
      {projects && projects.length > 0 ? (
        projects.map(project => (
            <PortfolioCard
              allocation={project.Team_Allocation}
              width={'auto'}
              key={project._id}
              arrowBackground={COLORS.PRODUCTS_ARROW}
              arrowBorder={'none'}
              projectId={project._id}
              title={project.Name}
              category={project.Domain?.Name ? [project.Domain.Name] : []}
              caption={project.Caption ?? ''}
              expertises={project.Expertises.map(expertise => expertise.Name)}
              technologies={project.Technologies.map(tech => tech.Name)}
              imageUrl={project.Image}
              imageWidth={'100%'}
              initImageHeight="340px"
              halfImageHeight={'170px'}
              imageHeight={'340px'}
              border={'none'}
              isPortfolioPage={true}
            />
        ))
      ) : (
        <Text
          text={t('screen.portfolio.not_found')}
          color={COLORS.MAIN_RED}
          margin={'0 0 100px 0'}
        />
      )}
    </PortfolioListWrapper>
  );
};
const PortfolioListWrapper = styled(MotionPortfolioProjectList)`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 80px;
  overflow: hidden;
  
  @media screen and (${device.lg}) {
    gap: 60px;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  @media screen and (${device.sm}) {
    gap: 20px;
  }
  @media screen and (${device.xs}) {
    grid-template-columns: 1fr;
  }
`;
export { PortfolioList };
